import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
@Component({
  selector: "app-person-output-management-default",
  templateUrl: "./output-management-default.component.html",
  styleUrls: ["./output-management-default.component.css"],
})
export class PersonOutputManagementDefaultComponent {
  @Input() output_history_list: any[] = [];
  @Input() language_list: any[] = [];
  @Input() output_language_id: any = null;
  @Input() canOutputFlg: boolean = false;

  @Output() onOutput = new EventEmitter<void>();
  @Output() onReload = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<any>();
  @Output() onDownload = new EventEmitter<any>();
  @Output() onGetUploadFile = new EventEmitter<any>();
  @Output() onErrorClick = new EventEmitter<any>();
  @Output() output_language_idChange = new EventEmitter<any>();

  // ラベルテキストの判定 (Angular 5 パースエラー対策)
  getOutputLabel(h: any): string {
    if (h.output_result == 11) return "健診書類アップロードファイル";
    if (h.output_result == 12) return "再検査アップロードファイル";
    if (h.output_result == 13) return "まとめてダウンロード";
    return h.question_category_name || "";
  }

  // 言語変更通知
  onLanguageChange(val: any) {
    this.output_language_idChange.emit(val);
  }

  // ダウンロードボタン表示判定
  canDownload(h: any): boolean {
    return (
      (h.output_result == 1 ||
        h.output_result == 11 ||
        h.output_result == 12 ||
        h.output_result == 13) &&
      h.error_count == 0 &&
      h.output_file_name != null &&
      h.output_file_path != null
    );
  }

  // アクション実行
  goOutput() {
    this.onOutput.emit();
  }
  reload() {
    this.onReload.emit();
  }
  cancel(h: any) {
    this.onCancel.emit(h);
  }
  showError(h: any) {
    this.onErrorClick.emit(h);
  }

  download(h: any) {
    if (
      h.output_result == 11 ||
      h.output_result == 12 ||
      h.output_result == 13
    ) {
      this.onGetUploadFile.emit(h);
    } else {
      this.onDownload.emit(h);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/output-management/default/output-management-default.component.ts